document.addEventListener('DOMContentLoaded', () => {
	const cards = document.querySelectorAll('.orla-team-card');

	cards.forEach((card) => {
		const button = card.querySelector('.orla-read-more');

		card.addEventListener('click', (e) => {
			// ignore clicks on links or buttons
			if (e.target.closest('a')) return;

			card.classList.toggle('expanded');

			if (button.querySelector('.label')) {
				button.querySelector('.label').textContent =
					card.classList.contains('expanded') ? 'Ler menos' : 'Ler mais';
			}
		});
	});
});
